/**
 * @generated SignedSource<<58d3225671a408062c5db399c4e8d354>>
 * @relayHash cda164f40fa4248c9f89096b61520775
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID cda164f40fa4248c9f89096b61520775

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserResponse",
    "kind": "LinkedField",
    "name": "signOut",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignOutMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SignOutMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "cda164f40fa4248c9f89096b61520775",
    "metadata": {},
    "name": "SignOutMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "4862fa24635906e47bae965063cf81ff";

export default node;
